import(/* webpackMode: "eager" */ "/pri/components/site-header.tsx")